import { useCatalogProductIdParams, usePdpBaseInfo, usePdpConfig } from '@domains/pdp-common';

export const useFastShippingBannerService = () => {
  const { isZigzagApp } = usePdpConfig();
  const param = useCatalogProductIdParams();
  const { product } = usePdpBaseInfo(param);

  const handleClickBanner = () => {
    const url = product.shipping_send_date?.fast_shipping?.notice_banner?.landing_url ?? '';

    if (isZigzagApp) {
      window.location.assign(url);
      return;
    }

    window.open(decodeURIComponent(url.substring(url.indexOf('=') + 1)));
  };

  return {
    noticeBanner: product.shipping_send_date?.fast_shipping?.notice_banner ?? null,
    handleClickBanner,
  };
};
